import * as React from 'react';
import { styled } from '../theme-provider';
const StyledTableCell = styled.td.withConfig({ displayName: "StyledTableCell", componentId: "sc-10gtrlz" }) `&:not(tfoot td){border-bottom:${({ theme }) => theme.size.border.light} solid ${({ theme }) => theme.colors.border.divider};}padding:${({ theme }) => theme.size.static200} ${({ theme }) => theme.size.static0};word-wrap:break-word;overflow-wrap:break-word;white-space:normal;`;
export const TableCell = ({ children }) => {
    return React.createElement(StyledTableCell, null, children);
};
